import Emitter from "./Emitter";
import {constants} from "../../constants";

export default class GameLoadEnd extends Emitter {
    constructor(gb) {
        super(gb);
    }

    EXCITE_handler() {
        this.emitParent({ event: 'gameReady' });
    }

    IGT_handler() {
        this.emitParent({ event: 'gameReady' });
    }

    SPINGAMES_handler() {
        this.emitTop({ event: "game_ready" });
        this.emitParent({ event: "game_ready" });
    }

    BWIN_handler() {
        this.emitParent("loaded")
        this.emitTop("loaded")
    }

    GAMEIOM_handler() {
        this.emitParent(JSON.stringify({wrapperAction:"gameLoadingEnded"}));
        this.emitTop("LOAD_COMPLETE");
    }

    MGS_handler() {
        this.emitParent('{"Name" : "bridge_api_ready", "Origin" : "embeddedgame"}');
    }

    PLAYTECH_handler() {
        this.gb.isSpinning = false;
        // if (this.gb.walletProtocol === constants.PLAYTECH && this.gb.gameProviderCode === 'GAM' && this.gb.ptResFeat && this.gb.ptResFeat.includes('loadingstatus')) {
        //     let dataForW = {_type: "ucip.loadingstatus.g2wLoadingProgressNotification", progress: 100}
        //     this.emitParent(JSON.stringify(dataForW));
        // }

        if (this.gb.ptResFeat && this.gb.ptResFeat.includes('loadingstatus')) {
            let dataForW = {_type: "ucip.loadingstatus.g2wLoadingProgressNotification", progress: 100}
            if (this.gb.settings.nativeMobileApp) {
                dataForW.handled = true;
                window.parent.postMessage(JSON.stringify(dataForW));
            } else {
                this.emitParent(JSON.stringify(dataForW));
            }
        }

        setTimeout(() => {
            if (this.gb.ptResFeat && this.gb.ptResFeat.includes('loadingstatus')) {
                let data = {_type: "ucip.loadingstatus.g2wLoadingEndNotification"};
                let dataTwo = {_type: "ucip.loadingstatus.g2wGameReadyNotification"};
                if (this.gb.settings.nativeMobileApp) {
                    data.handled = true;
                    dataTwo.handled = true;
                    window.parent.postMessage(JSON.stringify(data));
                    window.parent.postMessage(JSON.stringify(dataTwo));
                } else {
                    this.emitParent(JSON.stringify(data));
                    this.emitParent(JSON.stringify(dataTwo));
                }
            }

        },100)
    }

    POKERSTARS_handler() {
        if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
            window.parent.postMessage(JSON.stringify({"msgId":"rg2xcLaunchGameDone"}), this.gb.api.settings.pokerstarsOrigin);
        } else {
            window.parent.postMessage(JSON.stringify({"msgId":"rg2xcLaunchGameDone"}), "*");
        }
    }

    LNWOGS_handler() {
        this.gb.wallet.gameLoaded();
    }

    _default(msg) {
        const data = msg ? { wpgaction: "loadEnd", param: msg } : { wpgaction: "loadEnd" };
        const dataParent = msg ? { wpgaction: "loadEnd.parent", param: msg } : { wpgaction: "loadEnd.parent" };

        this.emitTop(data);
        this.emitParent(dataParent);
        this.emitiOS(data);
    }
}
